import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CommentsSection />
        <FeaturesSection />
        <RankingSection />
        <CarouselSection />
        <IndexSection />
        <ContactSection />
        <FaqSection />
        <UpdatesSection />
        <TopicsSection />
        <CardsSection />
        <AboutSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}